// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export interface NonStreamingOrderByResult {
  orderByItems: any[];
  payload: any;
}

export interface OrderByDocument {
  orderByItems: any[];
  payload: any;
}
